const percentFormat = new Intl.NumberFormat('es-ES', { style: 'percent', maximumFractionDigits: 0 });
const decimalFormat = new Intl.NumberFormat('es-ES', { maximumFractionDigits: 1 });
const dateFormat = new Intl.DateTimeFormat('es-ES', { day: 'numeric', month: 'long', year: 'numeric' });

export const formatPercent = (part, total) => percentFormat.format(total ? part / total : 0);
export const formatDecimal = (value) => decimalFormat.format(value);
export const formatDate = (iso) => dateFormat.format(new Date(iso));
export const formatPosition = (position) => (position ? `${position}.º` : '—');
export const pad2 = (n) => String(n).padStart(2, '0');

export const INTENT_LABELS = {
  recomendacion: 'Recomendación',
  especialidad: 'Especialidad',
  urgencia: 'Urgencia',
  precio: 'Precio',
  cercania: 'Cercanía'
};

export const CATEGORY_LABELS = {
  resenas: 'Reseñas',
  'ficha-google': 'Ficha de Google',
  directorios: 'Directorios',
  web: 'Web',
  contenido: 'Contenido',
  redes: 'Redes sociales'
};

export const IMPACT_LABELS = {
  alto: 'Impacto alto',
  medio: 'Impacto medio',
  bajo: 'Impacto bajo'
};

// Score bands for the visibility meter (status colours, always paired with
// an icon and a text label).
export const scoreBand = (score) => {
  if (score < 40) return { key: 'critical', label: 'Visibilidad baja' };
  if (score < 70) return { key: 'warning', label: 'Visibilidad media' };
  return { key: 'good', label: 'Visibilidad alta' };
};
